var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSidebarStatistic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_628_2774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.19128 2.63264C6.68663 2.56201 7.09414 2.97495 7.09414 3.47482V8.90826H12.5276C13.0275 8.90826 13.4404 9.31577 13.3698 9.81112C13.1377 11.3947 12.3154 12.832 11.0678 13.8345C9.82024 14.8371 8.23967 15.3307 6.64326 15.2165C5.04685 15.1022 3.5527 14.3885 2.4606 13.2185C1.36851 12.0485 0.759272 10.5088 0.755127 8.90826C0.75483 7.38326 1.30431 5.90927 2.30279 4.7566C3.30127 3.60393 4.68183 2.84984 6.19128 2.63264ZM14.3949 8.00269C14.8458 8.00269 15.2343 7.67125 15.2434 7.22027L15.2443 7.09712C15.2443 6.25427 15.0763 5.41989 14.75 4.64277C14.4237 3.86565 13.9457 3.16141 13.344 2.57123C12.7423 1.98106 12.0289 1.51681 11.2456 1.20564C10.4623 0.894472 9.62481 0.742634 8.78213 0.759009C8.33115 0.768065 7.99971 1.15746 7.99971 1.60753V7.09712C7.99971 7.33729 8.09512 7.56762 8.26495 7.73745C8.43477 7.90728 8.66511 8.00269 8.90528 8.00269H14.3949Z",
    fill: "#A8ADBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_628_2774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidebarStatistic);
export default __webpack_public_path__ + "static/media/ic-sidebar-statistic.b5f88fc3f0dcf703c53d7272791af82e.svg";
export { ForwardRef as ReactComponent };